module.exports = __webpack_public_path__ + "img/Preferred-Partner.99aa809c.svg";